import React from 'react';
import { Route } from '../Routing/types';
import BiometricSettingsWrapper from './components/BiometricSettingsWrapper';
import GoalSettingsWrapper from './components/GoalSettingsWrapper';
import NutritionSettingsWrapper from './components/NutritionSettingsWrapper';

const dummy_t = (translationKey: string) => translationKey;

const descendantRoutes: Route[] = [
  {
    path: '/biometric-settings/*',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'all-settings',
    element: <BiometricSettingsWrapper />,
  },
  {
    path: '/goal-settings/*',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'all-settings',
    element: <GoalSettingsWrapper />,
  },
  {
    path: '/nutrition-settings/*',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'all-settings',
    element: <NutritionSettingsWrapper />,
  },
];

export default descendantRoutes;
